import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mangawhai-126/artifacts/lmyojf3d_NF%20Construction%202025%20copy.png";

const NAV = [
  { href: '/#home', label: 'Home' },
  { href: '/#gallery', label: 'Gallery' },
  { href: '/#location', label: 'Location' },
  { href: '/#options', label: 'Options' },
  { href: '/#enquire', label: 'Enquire' },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const requestViewing = () => {
    setOpen(false);
    if (pathname === '/') window.dispatchEvent(new CustomEvent('open-viewing', { detail: 'viewing' }));
    else navigate('/#enquire');
  };

  const linkClass = "text-[13px] tracking-[0.08em] uppercase text-white/85 hover:text-white transition-colors";

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="bg-[#1a1e1a]/90 backdrop-blur-md border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20 gap-6">
          <Link to="/" className="flex items-center shrink-0" data-testid="header-logo">
            <img src={LOGO_URL} alt="NF Construction" className="h-10 md:h-11 w-auto" style={{ filter: 'invert(1) brightness(1.5)' }} />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((l) => (
              <a key={l.href} href={l.href} className={linkClass} data-testid={`nav-${l.label.toLowerCase()}`}>{l.label}</a>
            ))}
            <Link to="/about" className={`${linkClass} ${pathname === '/about' ? 'text-[#d6cdb4]' : ''}`} data-testid="nav-builder">The Builder</Link>
          </nav>

          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={requestViewing}
              data-testid="header-viewing-btn"
              className="bg-[#c8bfa8] text-[#1a1e1a] px-4 md:px-5 py-2.5 text-xs md:text-[13px] tracking-[0.08em] uppercase font-medium hover:bg-white transition-colors whitespace-nowrap"
            >
              <span className="hidden sm:inline">Arrange a viewing</span>
              <span className="sm:hidden">Viewing</span>
            </button>
            <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-white/85" aria-label="Toggle menu" data-testid="mobile-menu-toggle">
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 top-20 bg-[#1a1e1a] lg:hidden z-40"
            data-testid="mobile-menu"
          >
            <nav className="flex flex-col items-center justify-center h-full gap-7">
              {NAV.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-xl text-white/90 hover:text-white">{l.label}</a>
              ))}
              <Link to="/about" onClick={() => setOpen(false)} className="text-xl text-white/90 hover:text-white">The Builder</Link>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
